// utils/reportDownloader.js
import api from '../api';

export const downloadEngagements = async (params) => {
  try {
    const response = await api.get('/reports/export', {
      params,
      timeout: 300000 //5mins
    });

    // The endpoint now returns JSON with message, reportId, and status
    return response.data;
  } catch (error) {
    console.error('Failed to start report generation:', error);
    throw error;
  }
};

export const downloadValidEngagements = async (params) => {
  try {
    const response = await api.get('/reports/export-valid', {
      params,
      timeout: 300000 //5mins
    });

    return response.data;
  } catch (error) {
    console.error('Failed to start valid report generation:', error);
    throw error;
  }
};

export const downloadInvalidEngagements = async (params) => {
  try {
    const response = await api.get('/reports/export-invalid', {
      params,
      timeout: 300000 //5mins
    });

    return response.data;
  } catch (error) {
    console.error('Failed to start invalid report generation:', error);
    throw error;
  }
};

export const downloadAutoRejectedEngagements = async (params) => {
  try {
    const response = await api.get('/reports/export-auto-rejected', {
      params,
      timeout: 300000 //5mins
    });

    return response.data;
  } catch (error) {
    console.error('Failed to start auto rejected report generation:', error);
    throw error;
  }
};

export const downloadUsers = async (params, filename = 'report.csv') => {
  try {
    const response = await api.get('/reports/export/users', {
      params,
      responseType: 'blob',
      timeout: 300000 //5mins
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
  }
};

export const queueDistributionReport = async ({ startDate, endDate, projectId, status } = {}) => {
  const res = await api.get('/reports/distribution/export', {
    params: {
      startDate: startDate || undefined,
      endDate: endDate || undefined,
      projectId: projectId || undefined,
      status: status || undefined,
    },
    timeout: 300000,
  });
  return res.data;
};

export const downloadStores = async (params, filename = 'report.csv') => {
  try {
    const response = await api.get('/reports/export/dynamic-stores', {
      params,
      responseType: 'blob',
      timeout: 300000 //5mins
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
  }
};



export const downloadActivities = async (params, filename = 'report.csv') => {
  try {
    const response = await api.get('/reports/export/activities', {
      params,
      responseType: 'blob',
      timeout: 300000 //5mins
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
  }
};

export const queueGIReport = async ({ startDate, endDate } = {}) => {
  const res = await api.get('/reports/gi/export', {
    params: {
      startDate: startDate || undefined,
      endDate: endDate || undefined,
    },
    timeout: 300000,
  });
  return res.data;
};

export const listReports = async ({ page = 1, limit = 10 } = {}) => {
  try {
    const res = await api.get('/reports', { params: { page, limit } });
    return res.data;
  } catch (error) {
    console.error('Error listing reports:', error);
    return { reports: [], pagination: { total: 0, page: 1, limit, pages: 0 } };
  }
};

export const downloadReportFile = async (reportId, filename = 'report.csv') => {
  try {
    const response = await api.get(`/reports/download/${reportId}`, {
      timeout: 900000 //15mins - longer timeout for file downloads
    });

    const downloadUrl = response?.data?.downloadUrl;
    if (!downloadUrl) {
      throw new Error('No download URL returned by the server');
    }

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Failed to download report file:', error);
    throw error;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const response = await api.delete(`/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to delete report:', error);
    throw error;
  }
};

export const cancelReport = async (reportId) => {
  try {
    const response = await api.post(`/reports/${reportId}/cancel`);
    return response.data;
  } catch (error) {
    console.error('Failed to cancel report:', error);
    throw error;
  }
};
